import React, { useEffect, useState } from 'react';
import { Form, Button, Col, Row, Input, InputNumber } from 'antd';
import UploadFile from '../../../components/basic/uploadFile';
import { AvatarModel } from '../../../models/course';
import APIServices from '../../../lib/APIServices';

interface Props {
    initialValues: any | undefined
    onSubmit: (user: any) => void
    onClose: () => void
}
const CartoonForm = (props: Props) => {
    const [form] = Form.useForm();

    const onFinish = (values: any) => {
        values._id = props.initialValues && props.initialValues._id;

        props.onSubmit(values);
    };

    const onFieldsChange = async () => {
        if (props.initialValues && props.initialValues._id) {
            const newData = (await APIServices.getCartoon(props.initialValues._id)).data;
            form.setFieldsValue(newData);
        } else {
            form.resetFields();
        }
    };

    useEffect(() => {
        onFieldsChange();
    }, []);
    return (
        <Form
            layout='vertical'
            // hideRequiredMark
            // initialValues={props.initialValues}
            form={form}
            onFinish={onFinish}
        >
            <Row gutter={12}>
                <Col span={12}>
                    <Form.Item
                        name='title'
                        label='Title'
                        rules={[{ required: true, message: 'Please enter the title of the cartoon' }]}
                    >
                        <Input placeholder='Please enter the title of the cartoon' />
                    </Form.Item>
                </Col>
                <Col span={6}>
                    <Form.Item
                        name='link'
                        label='Link <AU1-1-Hi.mp4>'
                    >
                        <Input placeholder='Please enter cartoon Link' />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={16}>
                <Col span={24} className='btn'>
                    <Form.Item>
                        <Button htmlType='button' onClick={props.onClose}>
                            Cancel
                        </Button>
                        <Button type='primary' htmlType='submit' className='submit'>
                            Submit
                        </Button>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
};

export default CartoonForm;
